export default __webpack_public_path__ + "static/media/obj.fcc51f8a.svg";